import { formatPrice } from '@utils/strings'
import classNames from 'classnames'
import { useMemo } from 'react'

export function SubtotalLineItem({
  name,
  total,
  currency,
  languageCode,
  nameClassName,
  totalClassName,
}: {
  name: string
  total: number
  currency?: string
  languageCode?: string | null
  nameClassName?: string
  totalClassName?: string
}) {
  const priceLabel = useMemo(() => {
    return formatPrice(total, { currency, languageCode })
  }, [currency, languageCode, total])

  return (
    <div className='flex items-center justify-between w-full'>
      <span
        className={classNames(
          nameClassName,
          'text-sm sm:text-base truncate text-ellipsis'
        )}
      >
        {name}
      </span>
      <span className={classNames(totalClassName, 'text-sm sm:text-base')}>
        {priceLabel}
      </span>
    </div>
  )
}
